import React from 'react';

import { CircularProgress, Button as MuiButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import useClassNames from '~/hooks/use-classnames';
import colors from '~/values/colors';

const useStyles = makeStyles({
    root: {
        background: props => props.variant === 'contained' && colors[props.color],
        color: props => (props.variant === 'text' || props.variant === 'outlined') && colors[props.color],
        borderColor: props => props.variant === 'outlined' && colors[props.color],
    },
});

const Button = props => {
    const {
        loading, startIcon, disabled, className, ...others
    } = props;

    const classes = useStyles(props);

    const buttonClasses = useClassNames([classes.root, className]);

    const renderStartIcon = () => {
        if (loading) {
            return <CircularProgress size={18} />;
        }
        return startIcon;
    };

    return (
        <MuiButton
            {...others}
            className={buttonClasses}
            disabled={disabled || loading}
            startIcon={renderStartIcon()}
        />
    );
};

Button.defaultProps = {
    variant: 'text',
};

export default Button;
